import AdmissionOpenImage from '../assets/images/admission.png'; // Adjust the path as needed

const Admission = () => {

    return (
        <section className="ftco-section ftco-no-pt ftco-no-pb">
            <div className="container">
                <div className="row justify-content-center mt-3 pb-4">
                    <div className="col-md-12 heading-section ftco-animate text px-4">
                        <h2 className="mb-4 text-success text-center">
                        Admissions Open for 2025-2026!
                        </h2>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-12 order-md-first">
                        <div className="text px-4">

                           <p>Dear Parents and Students,

We are delighted to announce that admissions for the 2024-2025 academic year are now open at SRN Matriculation School! We welcome aspiring students to join our institution, where we nurture young minds with quality education, creativity, and leadership skills.</p>

<img 
                                src={AdmissionOpenImage} 
                                alt="Admission Open for B.Ed. Programme" 
                                className="img-fluid" 
                                width="100%" 
                                height="auto" 
                            />
                            <h2 className="mb-4 text-secondary">
                            Why Choose SRN Matriculation School?
                            </h2>
                            <p>
                            ✅ Holistic education with a focus on academic excellence<br />
                            ✅ Experienced and dedicated faculty<br/>
                            ✅ State-of-the-art facilities and modern learning resources<br/>
                            ✅ Emphasis on extracurricular activities and skill development<br/>
                                ✅ Safe and nurturing learning environment</p>
                            

                                <h2 className="mb-4 text-secondary">
                                Admission Process:
                            </h2>
                            <p>
                            🔹 Step 1: Collect the admission form from the school office or download it from our website.<br/>
                            🔹 Step 2: Submit the duly filled application form along with the required documents.<br/>
                            🔹 Step 3: Attend the entrance assessment (if applicable).<br/>
                            🔹 Step 4: Complete the admission formalities upon selection.<br/>
                            </p>
                            <h2 className="mb-4 text-secondary">
                            Important Dates:
                            </h2>
                            <p>
                            📅 Admission Open From: [Start Date]<br/>
                            📅 Last Date to Apply: [Deadline]<br/>

                            For more details, visit our school office or contact us at:<br/>
                            📞 +91 98949 93212<br/>
                            📧 srnschool2015@gmail.com<br/>
                            We look forward to welcoming new students into our learning community and shaping a bright future together!
                            </p>

 </div>
                    </div>
                </div>
        </div>
        <hr className="custom-hr"/>
        </section>
    );
};

export default Admission;
